import {
  CATALOG_PAGE_LIMIT_MAX,
  type SortType,
} from "@/features/catalog/stores/catalogStore";
import { boardApiPath } from "@/shared/api/boardPath";

export function getCatalogPath(
  sortType: SortType,
  page: number,
  limit: number,
): string {
  return `${boardApiPath("/catalog")}${catalogQuery(sortType, page, limit)}`;
}

/** 総合カタログが任意板のカタログを引くためのslug明示版。 */
export function getBoardCatalogPath(
  slug: string,
  sortType: SortType,
  page: number,
  limit: number,
): string {
  return `/catalog/${encodeURIComponent(slug)}${catalogQuery(sortType, page, limit)}`;
}

/**
 * 制御なし群向けのサーバーサイド混合カタログ。bはカンマ区切り(最大5板)で、
 * 板をまたいだ並び順とページングをbackendが保証する。
 */
export function getCatalogMixPath(
  slugs: readonly string[],
  sortType: SortType,
  page: number,
  limit: number,
): string {
  const boards = slugs.map((slug) => encodeURIComponent(slug)).join(",");
  return `/catalog-mix${catalogQuery(sortType, page, limit)}&b=${boards}`;
}

function catalogQuery(sortType: SortType, page: number, limit: number): string {
  const normalizedPage = Number.isFinite(page)
    ? Math.max(1, Math.floor(page))
    : 1;
  const normalizedLimit = Number.isFinite(limit)
    ? Math.max(1, Math.min(CATALOG_PAGE_LIMIT_MAX, Math.floor(limit)))
    : CATALOG_PAGE_LIMIT_MAX;
  return `?sort=${sortType}&page=${normalizedPage}&limit=${normalizedLimit}`;
}
